<nav aria-label="breadcrumb" class="d-flex">
    <ol class="breadcrumb m-auto fw-medium">
        <li *ngFor="let item of breadcrumbs; let i = index; let last = last" class="breadcrumb-item"
            [ngClass]="{'last-item': last}">
            <a class="text-decoration-none" [routerLink]="item.url">{{ item.label }}</a>
        </li>
    </ol>
</nav>